import React from 'react';
import { string, bool } from 'prop-types';

import * as S from './styles';

const Clickable = ({ to, isExternal, ...props }) => {
  if (!to) {
    return <S.Button {...props} />;
  }

  return isExternal ? (
    <S.ExternalLink href={to} {...props} />
  ) : (
    <S.InternalLink to={to} {...props} data-test="InternalLink" />
  );
};

Clickable.propTypes = {
  to: string,
  isExternal: bool,
};

Clickable.defaultProps = {
  to: undefined,
  isExternal: false,
};

export default Clickable;
